import WorkChartsEditor from "./WorkChartsEditor";

export default WorkChartsEditor;
